import { IDistriwinFeedRegistration } from 'shared/api/api';

export const GET_DISTRIWIN_FEED_REGISTRATIONS = 'GET_DISTRIWIN_FEED_REGISTRATIONS';

export interface DistriwinFeedRegistrationState {
	distriwinFeedRegistrations: IDistriwinFeedRegistration[];
}
